// Only explicit diagnostic fields leave the device; never export session data.
const FIELDS = ['at', 'event', 'state', 'screen', 'socket', 'reconnect', 'gameId', 'preset', 'boardSize', 'yourTurn', 'hadResult', 'hasClocks', 'mineMs', 'opponentMs', 'reason', 'awayMs', 'closeCode', 'clean', 'clientVersion', 'serverVersion', 'completedGames', 'unlockedSizes', 'statusCode','viewportWidth','viewportHeight','standalone'];
function diagnosticReport(entries, now = new Date().toISOString()) {
  const events = (Array.isArray(entries) ? entries : []).slice(-160).map(entry => {
    const clean = {};
    for (const field of FIELDS) {
      const value = entry?.[field];
      if (typeof value === 'string') clean[field] = value.slice(0, 160);
      else if (typeof value === 'boolean' || (typeof value === 'number' && Number.isFinite(value))) clean[field] = value;
    }
    return clean;
  });
  return JSON.stringify({ version: 'v227', schemaVersion: 2, exportedAt: now, events }, null, 2);
}
module.exports = { diagnosticReport };
